import { Children, cloneElement } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { useEnforceUpgrade } from 'components/billing/useEnforceUpgrade'
import {
  isAvailableFeatureSelector,
  isRestrictedOnTrialFeatureSelector,
  setAnalyticsLocation
} from 'features/billing'

const BillingClickCapture = ({
  featureName,
  children,
  onClick,
  skipPreface = false,
  paywall = null,
  noTracking = false,
  paywallOverride = null,
  location = null
}) => {
  const dispatch = useDispatch()

  const isAvailable = useSelector(
    featureName
      ? (state) => (isAvailableFeatureSelector(state, { featureKey: featureName })
        && !isRestrictedOnTrialFeatureSelector(state, { featureKey: featureName }))
      : () => true
  )
  const enforceUpgrade = useEnforceUpgrade(featureName, { skipPreface, paywall, noTracking, paywallOverride })

  const onClickCapture = (event) => {
    if (isAvailable) return

    event.persist()
    event.preventDefault()
    event.stopPropagation()

    if (location) dispatch(setAnalyticsLocation(location))
    if (onClick) onClick()

    enforceUpgrade(() => {
      event.target.click()
    })
  }

  return Children.map(children, (child) => (
    cloneElement(child, { onClickCapture })
  ))
}

export default BillingClickCapture
